var isco1 = $('#isco-1');
var isco2 = $('#isco-2');
var isco3 = $('#isco-3');
var isco4 = $('#isco-4');

var ISCO = function(){

    
    var _init = function(){

        $('#isco-1').select2({minimumResultsForSearch:Infinity,placeholder:'-'});
        $('#isco-2').select2({minimumResultsForSearch:Infinity,placeholder:'-'});
        $('#isco-3').select2({minimumResultsForSearch:Infinity,placeholder:'-'});
        $('#isco-4').select2({minimumResultsForSearch:Infinity,placeholder:'-'});
        
        $('#save-occ-group').on('click',function(){
            Do.Ajax('/user/isco',{
                form:$('#isco').serializeJSON()
            });
        });

        var newOptions = '<option></option>';
        
        isco1.on('change', function() {
            isco2.prop('disabled',true).html(newOptions);
            isco3.prop('disabled',true).html(newOptions);
            isco4.prop('disabled',true).html(newOptions);
            ISCO.options(isco1,isco2);
            ISCO.check();
            isco1.removeClass('disabled').addClass('cursor-pointer');
        });
        
        isco2.on('change', function() {
            isco3.prop('disabled',true).html(newOptions);
            isco4.prop('disabled',true).html(newOptions);
            ISCO.options(isco2,isco3);
            ISCO.check();
        });
        
        isco3.on('change', function() {
            isco4.prop('disabled',true).html(newOptions);
            ISCO.options(isco3,isco4);
            ISCO.check();
        });
        
        isco4.on('change', function() {
            ISCO.check();
        });

    }

    var _check = function(){
        if(isco4.children("option").filter(":selected").index()<=0 ){
            if(isco3.children("option").filter(":selected").index()<=0 ){
                if(isco2.children("option").filter(":selected").index()<=0 ){
                    if(isco1.children("option").filter(":selected").index()<=0 ){
                        $('#chosen-group').html(nsl);
                    }else{
                        ISCO.setGroup(isco1);
                    }
                }else{
                    ISCO.setGroup(isco2);
                }
            }else{
                ISCO.setGroup(isco3);
            }
        }else{
            ISCO.setGroup(isco4);
        }
    }

    var _setGroup = function(parent){
        var sel = parent.children("option").filter(":selected");
        $('#chosen-group').html(sel.text());
        $('#isco-code').val(sel.val());
    }

    var _options = function(parent,child){
        Do.Ajax("/isco/"+parent.attr('id')+"/"+$('#'+parent.attr('id')+' option:selected').val(),{
            _method:'GET',
            child:child.attr('id')
        });
    };

    return {
        init: function(){
            _init();
        },
        check: function(){
            _check();
        },
        setGroup: function(g){
            _setGroup(g);
        },
        options: function(p,c){
            _options(p,c);
        }
    }
}();

var updateIscoOptions = function( response ){
    
    var newOptions = '<option></option>';
    
    var child = $('#'+response.child);

    child.select2({
        minimumResultsForSearch:Infinity,
        placeholder:'-',
        allowClear:true
    });

    if(response.items && Array.isArray(response.items)==false){
        for(var id in response.items) {
            newOptions += '<option value="'+ id +'">'+ response.items[id] +'</option>';
        }
        child.prop('disabled',false).html(newOptions);
    }else{
        child.prop('disabled',true).html('');
    }

}
